import { BinanceTable } from "@/components";


export const homeTabs = [
    {
        id: 1,
        title: "Market Place",
        content: <BinanceTable />,
    }
]